import React, { useMemo } from 'react';
import GenericListPage from '../GenericListPage';
import PromotionForm from './PromotionForm';
import { Link } from 'react-router-dom';

const PromotionsPage = () => {
  const columns = useMemo(() => [
    { header: 'Name', key: 'name', render: r => r.name || '—' },
    { header: 'Type', key: 'type', render: r => r.type || '—' },
    { header: 'Value', key: 'value', render: r => r.value != null ? r.value : '—' },
    { header: 'Active', key: 'isActive', render: r => r.isActive ? 'Yes' : 'No' },
    { header: 'Start', key: 'startDate', render: r => r.startDate ? new Date(r.startDate).toLocaleString() : '—' },
    { header: 'End', key: 'endDate', render: r => r.endDate ? new Date(r.endDate).toLocaleString() : '—' },
    { header: 'Created', key: 'createdAt', render: r => r.createdAt ? new Date(r.createdAt).toLocaleString() : '—' }
  ], []);

  const headerActions = (
    <div className="flex items-center gap-2">
      <Link to="/promotions/new">
        <button className="bg-green-600 text-white px-3 py-1 rounded text-sm">+ New Promotion</button>
      </Link>
    </div>
  );

  const filterConfig = [
    { name: 'isActive', type: 'select', label: 'Active', options: [{ value: '', label: 'Any' }, { value: 'true', label: 'Active' }, { value: 'false', label: 'Inactive' }] },
    { name: 'name', type: 'text', label: 'Name' }
  ];

  return (
    <GenericListPage
      title="Promotions"
      permission="manage_promotions"
      entityEndpoint="promotions"
      columns={columns}
      FormComponent={PromotionForm}
      filterConfig={filterConfig}
      headerActions={headerActions}
    />
  );
};

export default PromotionsPage;